const AboutUs = () => {
  return (
    <div className="text-color page-copy">
      <h4 className="mb-3">Acerca de TUBID</h4>
      <b>
      A través de TUBID, los consumidores en Guatemala pueden adquirir directamente bienes y servicios desde la comodidad de su hogar, sin necesidad de intermediarios. Esta plataforma de subastas en línea permite a los usuarios navegar por una amplia variedad de productos, hacer ofertas y concretar compras utilizando sus computadoras o dispositivos móviles. BidZone se enmarca dentro del comercio electrónico, o e-commerce, un modelo que facilita la compra y venta de bienes y servicios a través de Internet, además de manejar la transferencia de dinero y datos para ejecutar estas transacciones de manera segura y eficiente.
        <br />
      
     
      </b>
    </div>
  );
};

export default AboutUs;
